var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.86128 10.1953C7.12163 9.93491 7.54374 9.93491 7.80409 10.1953L11.9993 14.3905L16.1946 10.1953C16.455 9.93491 16.8771 9.93491 17.1374 10.1953C17.3978 10.4556 17.3978 10.8777 17.1374 11.1381L12.4708 15.8047C12.2104 16.0651 11.7883 16.0651 11.5279 15.8047L6.86128 11.1381C6.60093 10.8777 6.60093 10.4556 6.86128 10.1953Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow);
export default __webpack_public_path__ + "static/media/dropdown-arrow.067f235e29126c821f606d4b68a279a3.svg";
export { ForwardRef as ReactComponent };